import JournalEntry from 'src/models/accounting/JournalEntry'
import Model, { ID, IsoDate, IsoDateTime, MODEL_LEVEL } from 'src/models/model'

export const ACCOUNTING_DAY_STATES = {
  INCOMPLETE: 'incomplete',
  DIRTY: 'dirty',
  TRIAL: 'trial',
  FINAL: 'final',
  EMPTY: 'empty'
}

export default class AccountingDay extends Model {
  static name = 'AccountingDay'

  static versioned = true

  static paginate = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Financial]

  static noId = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true,
        required: false
      },
      date: {
        type: IsoDate,
        default: null,
        sortable: true
      },
      state: {
        type: String,
        output: true
      },
      journalEntries: {
        type: [JournalEntry],
        output: true
      },
      notes: {
        type: String
      },
      balance: {
        type: Number,
        output: true
      },
      isAccountingDayEnded: {
        type: Boolean,
        output: true
      },
      hasJournalEntries: {
        type: Boolean,
        output: true
      },
      externalSyncEnabled: {
        type: Boolean,
        output: true
      },
      finalizedAt: {
        type: IsoDateTime,
        output: true
      },
      externalSyncAt: {
        type: IsoDateTime,
        output: true
      },
      markedDirtyAt: {
        type: IsoDateTime,
        output: true
      },
      lastBuiltAt: {
        type: IsoDateTime,
        output: true
      },

      action: {
        type: String,
        input: true
      }
    }

    this.computed = {
      locked () {
        return this.state === 'Final'
      },
      invalidatedState () {
        return [ACCOUNTING_DAY_STATES.DIRTY, ACCOUNTING_DAY_STATES.EMPTY].includes(this.state)
      },
      disableFinalize () {
        return !this.isAccountingDayEnded || this.invalidatedState || !this.hasJournalEntries
      }
    }
  }

  async validate (date, force = false) {
    this.action = force ? 'force_validate' : 'validate'
    this.date = date

    await this.save()

    this.resetField('action')
  }

  async finalize () {
    this.action = 'finalize'

    await this.save()

    this.resetField('action')
  }

  async unlock () {
    this.action = 'unlock'

    await this.save()

    this.resetField('action')
  }
}
